module.exports = __webpack_public_path__ + "img/news_detail_1_3.6d25251b.png";